<template>
  <div class="border border-[#E2E2E2] rounded-lg p-[1.5rem]">
    <!-- Header with Title & Tools -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-[1rem]">
      <h2 class="text-[#333333] text-[18px] font-semibold">
        Daftar Akun Terkendala
      </h2>

      <div class="flex items-center gap-[0.625rem] w-full md:w-auto">
        <!-- Search Input -->
        <div
          class="flex items-center w-full md:!w-[340px] rounded-[8px] gap-[0.5rem] px-[0.75rem] border-[1px] border-[#E2E2E2] h-[40px]"
        >
          <span
            class="k-search-normal-1 font-bold align-middle text-[#828282]"
            style="font-size: 20px"
          />
          <BFormInput
            v-model="filter.keyword"
            placeholder="Cari Nama Akun, Email, ID Ad Acc..."
            class="border-0 grow !p-0 !text-[14px]"
            @input="onSearch"
          />
        </div>

        <!-- Filter Button & Popover -->
        <div class="flex items-center flex-row relative">
          <BButton
            id="filter"
            size="sm"
            variant="primary"
            class="position-relative"
            @click="showFilter = !showFilter"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              alt="Komerce"
              width="20"
            >
            <span
              v-if="activeFilterCount > 0"
              class="bg-[#F95031] -top-4 badge position-absolute start-100 translate-middle rounded-pill"
            >
              <span class="text-white font-semibold">{{
                activeFilterCount
              }}</span>
            </span>
          </BButton>
          <ul
            v-if="showFilter"
            ref="filterContainer"
            class="d-block position-absolute border bg-white right-0 top-[calc(100%_+_5px)] z-20 text-black font-medium text-[12px] rounded-xl"
          >
            <div class="text-black pl-2 py-1 text-[16px] border rounded-t-xl">
              Filter
            </div>
            <!-- Jenis Kendala -->
            <div
              class="hover:bg-[#FCD4BE] relative"
              tabindex="-1"
              @focusin="isJenisKendalaFocused = true"
              @focusout="event => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  isJenisKendalaFocused = false
                }
              }"
            >
              <div
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Jenis Kendala</span>
                <div
                  v-if="filledSelectedJenisKendala.length > 0"
                  class="text-primary ml-[5px]"
                >
                  ({{ filledSelectedJenisKendala.length }})
                </div>
              </div>
              <div
                :class="isJenisKendalaFocused ? 'block' : 'hidden'"
                class="absolute right-[calc(100%_+_5px)] bottom-0 bg-white min-w-[240px] p-[1rem] border rounded-md shadow space-y-[1rem]"
              >
                <div
                  v-for="(item, index) in currentJenisKendalaOptions"
                  :key="index"
                >
                  <b-form-checkbox
                    :checked="isJenisKendalaChecked(item.value)"
                    class="custom-control-primary"
                    name="jenis-kendala-checkbox"
                    @change="toggleJenisKendalaOption(item.value)"
                  >
                    <span class="text-[#333333] hover:cursor-pointer font-medium">
                      {{ item.text }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <!-- Pilih Business Manager -->
            <div
              class="hover:bg-[#FCD4BE] relative"
              tabindex="-1"
              @focusin="isBmFocused = true"
              @focusout="event => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  isBmFocused = false
                }
              }"
            >
              <div
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Pilih Business Manager</span>
                <div
                  v-if="filledSelectedBm.length > 0"
                  class="text-primary ml-[5px]"
                >
                  ({{ filledSelectedBm.length }})
                </div>
              </div>
              <div
                :class="isBmFocused ? 'block' : 'hidden'"
                class="absolute right-[calc(100%_+_5px)] bottom-0 bg-white min-w-[240px] p-[1rem] border rounded-md shadow space-y-[1rem] max-h-[240px] overflow-y-auto"
              >
                <div
                  v-for="(item, index) in bmOptions"
                  :key="index"
                >
                  <b-form-checkbox
                    :checked="isBmChecked(item.value)"
                    class="custom-control-primary"
                    name="bm-checkbox"
                    @change="toggleBmOption(item.value)"
                  >
                    <span class="text-[#333333] hover:cursor-pointer font-medium">
                      {{ item.text }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <!-- Tanggal Kendala -->
            <div class="hover:bg-[#FCD4BE]">
              <date-range-picker
                ref="picker"
                v-model="tempFilter.dateRange"
                :locale-data="locale"
                :ranges="datePickerRanges"
                :max-date="new Date()"
                :opens="'left'"
                :append-to-body="true"
                class="w-100"
                control-container-class="border-0"
                @toggle="handleDatePickerToggle"
              >
                <template v-slot:input>
                  <div class="d-flex btn">
                    <span>Tanggal Kendala</span>
                    <div
                      v-if="tempFilter.dateRange.startDate && tempFilter.dateRange.endDate"
                      class="text-primary ml-[5px]"
                    >
                      (1)
                    </div>
                  </div>
                </template>
              </date-range-picker>
            </div>
            <div class="border-t-2 p-[1rem] justify-between d-flex gap-[1rem]">
              <b-button
                variant="outline-primary"
                class="w-40 rounded-lg"
                @click="resetFilter"
              >
                Reset Filter
              </b-button>
              <b-button
                type="submit"
                variant="primary"
                class="w-40 rounded-lg"
                @click="applyFilter"
              >
                Terapkan
              </b-button>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs (Array driven) -->
    <div class="mt-[1.25rem] flex gap-[1.5rem] border-b-[1px] border-[#E2E2E2]">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="activeTab === tab.key ? 'border-b-[2px] text-[#F95031] border-[#F95031] font-medium' : 'text-[#626262] font-normal'"
        class="flex gap-[0.375rem] items-center pb-[0.625rem] cursor-pointer"
        @click="handleActiveTab(tab.key)"
      >
        <span
          :class="tab.icon"
          class="text-[16px]"
        />
        <span class="text-[14px]">{{ tab.label }}</span>
      </div>
    </div>

    <!-- Table Section -->
    <BOverlay
      :show="loadingTable"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="account-issues-table-container"
        ref="tableContainer"
        class="overflow-x-auto overflow-y-auto max-h-[600px] mt-[1rem]"
        :class="{ 'min-h-[200px]': loadingTable }"
      >
        <b-table-simple class="w-full table-auto !min-w-full border-collapse">
          <!-- Dynamic Table Header -->
          <b-thead class="bg-[#F8F8F8] !capitalize table-head-capitalize !sticky !top-0 !z-10">
            <b-tr>
              <b-th
                v-for="col in tableColumns"
                :key="col.key"
                class="align-middle !border-none !px-[1rem] !py-[.5rem] text-[#626262] font-semibold text-[14px] !capitalize bg-[#F8F8F8]"
                :class="col.thClass"
              >
                {{ col.label }}
              </b-th>
            </b-tr>
          </b-thead>

          <!-- Table Body -->
          <b-tbody class="divide-y divide-[#F4F4F4]">
            <b-tr
              v-for="(item, index) in items"
              :key="index"
              class="hover:bg-gray-50"
            >
              <!-- Waktu -->
              <b-td
                v-if="activeTab == 'all_issue'"
                class="!p-[1rem] align-middle !min-w-[180px]"
              >
                <div class="font-medium text-[#333333] text-[14px] leading-tight">
                  {{ item.created_at ? DAY_MONTH_YEAR(item.created_at) : '-' }}
                </div>
                <div class="text-[#626262] text-[12px] mt-[0.25rem]">
                  {{ item.created_at ? `${TIME(item.created_at)} WIB` : '-' }}
                </div>
              </b-td>
              <b-td
                v-else-if="activeTab == 'closed'"
                class="!p-[1rem] align-middle !min-w-[180px]"
              >
                <div class="font-medium text-[#333333] text-[14px] leading-tight">
                  {{ item.resolved_at ? DAY_MONTH_YEAR(item.resolved_at) : '-' }}
                </div>
                <div class="text-[#626262] text-[12px] mt-[0.25rem]">
                  {{ item.resolved_at ? `${TIME(item.resolved_at)} WIB` : '-' }}
                </div>
              </b-td>

              <!-- Nama Akun -->
              <b-td class="!p-[1rem] align-middle !max-w-[250px]">
                <div class="font-medium text-[#333333] text-[14px] leading-tight">
                  {{ item.account_name }}
                </div>
                <div class="text-[#626262] text-[12px] mt-[0.25rem]">
                  {{ item.partner_email }}
                </div>
              </b-td>

              <!-- Business Manager -->
              <b-td class="!p-[1rem] align-middle text-[#333333] text-[14px] !min-w-[150px]">
                {{ item.business_manager }}
              </b-td>

              <!-- ID Ad Account -->
              <b-td class="!p-[1rem] align-middle text-[#333333] text-[14px]">
                {{ item.ad_account_id }}
              </b-td>

              <!-- Estimasi Saldo -->
              <b-td class="!p-[1rem] align-middle text-[#333333] text-[14px] !min-w-[150px]">
                {{ IDR(item.estimated_balance || 0) }}
              </b-td>

              <!-- Status Badge -->
              <b-td class="!p-[1rem] align-middle text-center !w-[150px]">
                <span
                  class="px-[0.75rem] py-[0.25rem] rounded-full text-[12px] font-medium inline-block whitespace-nowrap"
                  :class="getStatusClass(item.status)"
                >
                  {{ getStatusLabel(item.status) }}
                </span>
              </b-td>

              <!-- Last Updated (All Issue Tab Only) -->
              <b-td
                v-if="activeTab === 'all_issue'"
                class="!p-[1rem] align-middle italic text-[#333333] text-[13px] whitespace-nowrap"
              >
                {{ item.last_updated ? DAY_MONTH_YEAR_COMMA_TIME(item.last_updated) : '-' }}
              </b-td>

              <!-- Action Link -->
              <b-td class="!p-[1rem] align-middle text-right">
                <span
                  class="text-[#08A0F7] font-medium text-[14px] cursor-pointer hover:underline"
                  @click="handleViewDetail(item)"
                >
                  Detail
                </span>
              </b-td>
            </b-tr>

            <b-tr v-if="items.length === 0 && !loadingTable">
              <b-td
                :colspan="tableColumns.length"
                class="text-center text-[#626262]"
              >
                <div class="h-[200px] flex">
                  <span class="m-auto">Data akun terkendala tidak ditemukan. Coba ubah kata kunci pencarian atau sesuaikan filter Anda.</span>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div
          ref="scrollSentinel"
          class="h-[1px] w-full"
        />
      </div>
    </BOverlay>
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import {
  YEAR_MONTH_DAY,
  DAY_MONTH_YEAR,
  TIME,
  DAY_MONTH_YEAR_COMMA_TIME,
} from '@/libs/filterDate'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  today, last7, last30, firstDateOfMonth,
} from '@/store/helpers'
import { ACCOUNT_STATUS_LABEL } from './constants'

export default {
  name: 'AccountIssuesTable',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      IDR,
      observer: null,
      activeTab: 'all_issue',
      loadingTable: false,
      isLastData: false,
      limit: 10,
      offset: 0,
      items: [],
      showFilter: false,
      isJenisKendalaFocused: false,
      isBmFocused: false,
      filter: {
        keyword: '',
        jenisKendala: [],
        businessManagers: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      tempFilter: {
        jenisKendala: [],
        businessManagers: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      tabs: [
        {
          key: 'all_issue',
          label: 'All Issue',
          icon: 'k-warning-2',
        },
        {
          key: 'closed',
          label: 'Closed',
          icon: 'k-user',
        },
      ],
      bmOptions: [],
      datePickerRanges: {
        Today: [today, today],
        'Last 7 Days': [last7, today],
        'Last 1 Month': [last30, today],
        'This Month': [firstDateOfMonth, today],
      },
      locale: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
      },
    }
  },
  computed: {
    currentJenisKendalaOptions() {
      if (this.activeTab === 'all_issue') {
        return [
          { value: 'semua', text: 'Semua' },
          { value: 'payment_issue', text: 'Payment Issue' },
          { value: 'restricted', text: 'Restricted' },
          { value: 'on_review', text: 'On Review' },
        ]
      }
      return [
        { value: 'semua', text: 'Semua' },
        { value: 'solved', text: 'Solved' },
        { value: 'replacement', text: 'Replacement' },
      ]
    },
    activeFilterCount() {
      let count = 0
      if (this.filledSelectedJenisKendala.length > 0) count += 1
      if (this.filledSelectedBm.length > 0) count += 1
      if (this.filter.dateRange && this.filter.dateRange.startDate && this.filter.dateRange.endDate) count += 1
      return count
    },
    filledSelectedJenisKendala() {
      return this.tempFilter.jenisKendala.filter(s => s !== 'semua')
    },
    filledSelectedBm() {
      return this.tempFilter.businessManagers.filter(s => s !== 'semua')
    },
    tableColumns() {
      const commonColumns = [
        { key: 'date', label: 'Waktu', thClass: '!rounded-l-lg' },
        { key: 'account_name', label: 'Nama Akun' },
        { key: 'bm_name', label: 'Business Manager' },
        { key: 'ad_account_id', label: 'ID Ad Account' },
        { key: 'estimated_balance', label: 'Estimasi Saldo' },
        { key: 'status', label: 'Status', thClass: '!text-center' },
      ]

      if (this.activeTab === 'all_issue') {
        return [
          ...commonColumns,
          { key: 'last_updated', label: 'Last Updated' },
          { key: 'action', label: '', thClass: '!rounded-r-lg text-right' },
        ]
      }

      return [
        ...commonColumns,
        { key: 'action', label: '', thClass: '!rounded-r-lg text-right' },
      ]
    },
  },
  async mounted() {
    await this.loadSystemBusinessManagerList()
    this.resetItems()
    await this.getAccountIssuesList()
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    DAY_MONTH_YEAR,
    TIME,
    DAY_MONTH_YEAR_COMMA_TIME,
    YEAR_MONTH_DAY,
    /**
     * Reset items pagination and list state.
     */
    resetItems() {
      this.offset = 0
      this.items = []
      this.isLastData = false
    },
    /**
     * to max bottom scroll
    */
    handleDatePickerToggle(open) {
      if (!open) return

      this.$nextTick(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        })
      })
    },
    /**
     * Fetch list of account issues based on filters and pagination
     */
    async getAccountIssuesList() {
      if (this.loadingTable) return
      this.loadingTable = true

      const params = {
        tab: this.activeTab,
        limit: this.limit,
        offset: this.offset,
      }

      if (this.filter.keyword) {
        params.keyword = this.filter.keyword
      }

      const activeStatuses = this.filter.jenisKendala.filter(s => s !== 'semua')
      if (activeStatuses.length > 0) {
        params.status = activeStatuses.length === 1 ? activeStatuses[0] : activeStatuses.join(',')
      }

      const activeBm = this.filter.businessManagers.filter(s => s !== 'semua')
      if (activeBm.length > 0) {
        params.system_bm_id = activeBm.length === 1 ? activeBm[0] : activeBm.join(',')
      }

      if (this.filter.dateRange && this.filter.dateRange.startDate && this.filter.dateRange.endDate) {
        params.start_date = YEAR_MONTH_DAY(this.filter.dateRange.startDate)
        params.end_date = YEAR_MONTH_DAY(this.filter.dateRange.endDate)
      }

      const url = 'komads/api/v1/admin/whitelist_account_issues/list'

      try {
        const res = await newAxiosIns.get(url, { params })
        const data = res && res.data ? res.data.data : []
        const list = Array.isArray(data) ? data : []

        if (list.length < this.limit) {
          this.isLastData = true
        } else {
          this.isLastData = false
        }

        const normalizedList = list.map(item => ({
          ...item,
          bm_name: item.business_manager,
          email: item.partner_email,
          account_type: item.ad_account_type,
        }))

        this.items.push(...normalizedList)
        this.offset += list.length
      } catch (error) {
        if (this.offset === 0) {
          this.items = []
        }
      } finally {
        this.loadingTable = false
      }
    },
    setupIntersectionObserver() {
      const sentinel = this.$refs.scrollSentinel
      if (!sentinel) return

      const options = {
        root: this.$refs.tableContainer || document.querySelector('#account-issues-table-container'),
        threshold: 0.1,
      }

      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0]
        if (entry && entry.isIntersecting && !this.isLastData && !this.loadingTable) {
          this.getAccountIssuesList()
        }
      }, options)

      this.observer.observe(sentinel)
    },
    resetAllFilter() {
      this.filter = {
        keyword: '',
        jenisKendala: [],
        businessManagers: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
      this.tempFilter = {
        jenisKendala: [],
        businessManagers: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
      this.showFilter = false
      this.isJenisKendalaFocused = false
      this.isBmFocused = false
    },
    async handleActiveTab(tab) {
      this.activeTab = tab
      this.resetAllFilter()
      this.resetItems()
      await this.getAccountIssuesList()
      this.$emit('tab-change', tab)
    },
    handleToggleFilter() {
      if (!this.showFilter) {
        this.tempFilter = {
          jenisKendala: [...this.filter.jenisKendala],
          businessManagers: [...this.filter.businessManagers],
          dateRange: {
            startDate: this.filter.dateRange ? this.filter.dateRange.startDate : null,
            endDate: this.filter.dateRange ? this.filter.dateRange.endDate : null,
          },
        }
      }
      this.showFilter = !this.showFilter
    },
    toggleJenisKendalaOption(val) {
      if (val === 'semua') {
        const nonSemuaOptions = this.currentJenisKendalaOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.jenisKendala.includes(o.value))
        if (allSelected) {
          this.tempFilter.jenisKendala = []
        } else {
          this.tempFilter.jenisKendala = this.currentJenisKendalaOptions.map(opt => opt.value)
        }
        return
      }

      const index = this.tempFilter.jenisKendala.indexOf(val)
      if (index > -1) {
        this.tempFilter.jenisKendala.splice(index, 1)
        const semuaIndex = this.tempFilter.jenisKendala.indexOf('semua')
        if (semuaIndex > -1) {
          this.tempFilter.jenisKendala.splice(semuaIndex, 1)
        }
      } else {
        this.tempFilter.jenisKendala.push(val)
        const nonSemuaOptions = this.currentJenisKendalaOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.jenisKendala.includes(o.value))
        if (allSelected && !this.tempFilter.jenisKendala.includes('semua')) {
          this.tempFilter.jenisKendala.push('semua')
        }
      }
    },
    isJenisKendalaChecked(val) {
      return this.tempFilter.jenisKendala.includes(val)
    },
    toggleBmOption(val) {
      if (val === 'semua') {
        const nonSemuaOptions = this.bmOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.businessManagers.includes(o.value))
        if (allSelected) {
          this.tempFilter.businessManagers = []
        } else {
          this.tempFilter.businessManagers = this.bmOptions.map(opt => opt.value)
        }
        return
      }

      const index = this.tempFilter.businessManagers.indexOf(val)
      if (index > -1) {
        this.tempFilter.businessManagers.splice(index, 1)
        const semuaIndex = this.tempFilter.businessManagers.indexOf('semua')
        if (semuaIndex > -1) {
          this.tempFilter.businessManagers.splice(semuaIndex, 1)
        }
      } else {
        this.tempFilter.businessManagers.push(val)
        const nonSemuaOptions = this.bmOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.businessManagers.includes(o.value))
        if (allSelected && !this.tempFilter.businessManagers.includes('semua')) {
          this.tempFilter.businessManagers.push('semua')
        }
      }
    },
    isBmChecked(val) {
      return this.tempFilter.businessManagers.includes(val)
    },
    async applyFilter() {
      this.filter.jenisKendala = [...this.tempFilter.jenisKendala]
      this.filter.businessManagers = [...this.tempFilter.businessManagers]
      this.filter.dateRange = {
        startDate: this.tempFilter.dateRange.startDate,
        endDate: this.tempFilter.dateRange.endDate,
      }
      this.showFilter = false
      this.resetItems()
      await this.getAccountIssuesList()
    },
    async resetFilter() {
      this.tempFilter.jenisKendala = []
      this.tempFilter.businessManagers = []
      this.tempFilter.dateRange = {
        startDate: null,
        endDate: null,
      }
      this.filter.jenisKendala = []
      this.filter.businessManagers = []
      this.filter.dateRange = {
        startDate: null,
        endDate: null,
      }
      this.showFilter = false
      this.resetItems()
      await this.getAccountIssuesList()
    },
    handleViewDetail(item) {
      this.$emit('view-detail', item)
    },
    getStatusClass(status) {
      const classes = {
        on_review: 'bg-[#E8F4FD] text-[#08A0F7]',
        restricted: 'bg-[#FFEDED] text-[#E31A1A]',
        payment_issue: 'bg-[#FEF2CD] text-[#FBBC05]',
        replacement: 'bg-[#F3E8FF] text-[#8B5CF6]',
        solved: 'bg-[#DCF3EB] text-[#34A770]',
      }
      return classes[status] || 'bg-gray-100 text-gray-600'
    },
    getStatusLabel(status) {
      return ACCOUNT_STATUS_LABEL[status] || status
    },
    onSearch: _.debounce(function search() {
      this.resetItems()
      this.getAccountIssuesList()
    }, 500),
    /**
     * Load system business manager options for filter
     */
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        if (Array.isArray(data) && data.length > 0) {
          this.bmOptions = [
            { value: 'semua', text: 'Semua' },
            ...data.map(system => ({
              value: system.id,
              text: system.bm_id ? `${system.bm_name} - ${system.bm_id}` : system.bm_name,
            })),
          ]
        }
      } catch {
        this.bmOptions = []
        this.$toast_error({ message: 'Gagal memperoleh bm list' })
      }
    },
  },
}
</script>

<style scoped>
h1,
h2,
p {
  @apply m-0;
}

.btn-primary {
  border-radius: 10px !important;
}
</style>
